import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CoreModule } from '../core/core.module';
import { OffersListComponent } from './offers-list/offers-list.component';
import { OffersService } from './services/offers.service';
import { OfferEditComponent } from './offer-edit/offer-edit.component';
import { RouterModule } from '@angular/router';
import { AvailabilityItemComponent } from './availability-item/availability-item.component';
import { ContactsListComponent } from './contact/contact.component';
import { ContactsComponent } from './contacts/contacts.component';

@NgModule({
  imports: [CommonModule, CoreModule, ReactiveFormsModule, RouterModule, FormsModule],
  exports: [OffersListComponent, OfferEditComponent],
  providers: [OffersService],
  declarations: [OffersListComponent, OfferEditComponent, AvailabilityItemComponent, ContactsListComponent, ContactsComponent],
})
export class OffersModule {}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/offers.module.ts